export default __webpack_public_path__ + "static/centre-de-tri-2-etcheverry-mindurry-6c92d78a50f3fa71f56cbed5dd79b1e2.jpg";